import React from 'react';
import { FieldLabel } from './FieldLabel';

export default function ObjectField({ k, value, onChange, Renderer }) {
  const v = value || {};
  const set = (key, nv) => onChange({ ...v, [key]: nv });
  return (
    <div className="space-y-4 bg-bg-secondary/40 border border-line rounded-md p-4">
      <div className="text-eyebrow text-ink-muted">{k}</div>
      {Object.keys(v).map((kk) => (
        <Renderer key={kk} k={kk} value={v[kk]} onChange={(nv) => set(kk, nv)} />
      ))}
    </div>
  );
}
